import * as React from 'react';
import { Link } from 'src/components/atoms';
import { FormInput } from 'src/components/molecules';
import { useGetGlobalFeaturesQuery } from 'src/graphql';
import { FormInputVariant, FormState } from 'src/types';
import * as Types from '../../../types';
import { LoginFlow } from '../../../types';
import { isRequiredFeatureEnabled } from '../../auth';
import { AcceptCookiesCheckbox } from '../../organismsLegacy';
import LoginContainer from '../LoginContainer';

interface Props {
  email: string;
  password: string;
  onPasswordChange: Function;
  setFlow: Function;
  handleOnClick: Function;
  loading: boolean;
}

function LoginPassword(props: Props) {
  const [cookiesCheckboxTicked, setCookiesCheckboxTicked] = React.useState(
    JSON.parse(localStorage.getItem('reshub-cookies-accepted')!) ?? false,
  );
  const [cookiesPopupState, setCookiesPopupState] = React.useState('hidden');

  const { data: featuresData } = useGetGlobalFeaturesQuery();
  const isCookiesConfirmationEnabled = isRequiredFeatureEnabled(
    (featuresData?.getGlobalFeatures as Types.Feature[]) ?? [],
    Types.FeatureFlag.COOKIE_CONSENT,
  );

  const getInputState = () => {
    if (!props.password || props.password.length <= 10) {
      return FormState.DEFAULT;
    }
    return FormState.SUCCESS;
  };

  const handleLogin = () => {
    if (cookiesCheckboxTicked || !isCookiesConfirmationEnabled) {
      props.handleOnClick();
      if (isCookiesConfirmationEnabled) {
        setCookiesPopupState('hidden');
        localStorage.setItem(
          'reshub-cookies-accepted',
          JSON.stringify(cookiesCheckboxTicked),
        );
      }
    } else {
      setCookiesPopupState('error');
    }
  };

  return (
    <div data-testid="password-input">
      <LoginContainer
        header="Log in"
        includeForm={true}
        buttonText="Continue"
        buttonOnClick={handleLogin}
        data-testid="enter-password"
        buttonDisabled={!props.password || !props.password.length}
        backButtonOnClick={() => props.setFlow(LoginFlow.USERNAME)}
        loading={props.loading}
      >
        <FormInput
          label="Password"
          variant={FormInputVariant.INPUT}
          placeholder="Password"
          autoComplete="current-password"
          data-testid="password-input"
          state={getInputState()}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            props.onPasswordChange(event.currentTarget.value);
          }}
          type="password"
          value={props.password}
          enterKeyAction={() => handleLogin()}
          $removeMarginBottom={true}
        />
        {isCookiesConfirmationEnabled && (
          <AcceptCookiesCheckbox
            checkboxTicked={cookiesCheckboxTicked}
            setCheckboxTicked={setCookiesCheckboxTicked}
            cookiesPopupState={cookiesPopupState}
            setCookiesPopupState={setCookiesPopupState}
            align="left"
          />
        )}
        <Link data-testid="password-input" to="/reset" size="medium">
          Forgot your password?
        </Link>
      </LoginContainer>
    </div>
  );
}

export default LoginPassword;
